/* eslint-disable max-len */
const RentDetailedJSON = {
  wizardName: 'Rental (Detailed)',
  wizardDescription: 'A more advanced rental deal template',
  items: [
    {
      name: 'Title',
      type: 'string',
      required: true,
      displayName: 'Deal Name',
    },
    {
      name: 'Description',
      type: 'string',
      required: false,
      displayName: 'Description',
    },
    {
      name: 'AgentContactName',
      type: 'agent',
      required: true,
      displayName: 'Agent',
      width: 50,
    },
    {
      name: 'TenantName',
      type: 'contact',
      required: true,
      displayName: 'Tenant',
      width: 50,
    },
    {
      name: 'LandlordName',
      type: 'contact',
      required: true,
      displayName: 'Landlord',
      width: 50,
    },
    {
      name: 'FMR',
      type: 'dollar',
      displayName: 'FMR Amount',
      width: 50,
    },
    {
      name: 'LMR',
      type: 'dollar',
      displayName: 'LMR Amount',
      width: 50,
    },
    {
      name: 'SEC',
      type: 'dollar',
      displayName: 'Security Deposit Fee',
      width: 50,
    },
    {
      name: 'FEE',
      type: 'dollar',
      displayName: 'Rental Fee',
      width: 50,
    },
    {
      name: 'COMM_SPLIT',
      type: 'dollar',
      displayName: 'Commission Split',
      width: 50,
    },
    {
      name: 'ContractDate',
      type: 'date',
      required: true,
      displayName: 'Contract Date',
      width: 50,
    },
    {
      name: 'SplitAgentName',
      type: 'agent',
      required: true,
      displayName: 'Splitting Agent',
      width: 50,
    },
    {
      name: 'PARKING',
      type: 'dollar',
      required: true,
      displayName: 'Parking',
      width: 50,
    },
    {
      name: 'KEY_FEE',
      type: 'dollar',
      displayName: 'Key Fee',
      width: 50,
    },
    {
      name: 'TransactionDate',
      type: 'date',
      required: true,
      displayName: 'Transaction Date',
      width: 50,
    },
    {
      name: 'StatusName',
      type: 'enum',
      required: true,
      displayName: 'Deal Status',
      enumOptions: ['Draft', 'Submitted', 'Approved'],
      width: 50,
    },
  ],
  wizard: [
    {
      name: 'FMR',
      required: true,
      displayName: 'First Months Rent Category',
      type: 'tranCategory',
      prompt:
        'Select a transaction category that represents First Months Rent.  Typically this category is "FMR - First Months Rent" and funds are both received and paid to an escrow account, which is any Liability Account in your general ledger.  You can set up a new category here if you don\'t have one already.',
    },
    {
      name: 'LMR',
      required: true,
      displayName: 'Last Months Rent Category',
      type: 'tranCategory',
      prompt:
        'Select a transaction category that represents Last Months Rent.  Typically this category is "LMR - Last Months Rent" and funds are both received and paid to an escrow account, which is any Liability Account in your general ledger.  You can set up a new category here if you don\'t have one already.',
    },
    {
      name: 'SEC',
      required: true,
      displayName: 'Security Deposit Category',
      type: 'tranCategory',
      prompt:
        'Select a transaction category that represents the Security Deposit.  Typically this category is "SEC - Secuirty Deposit" and funds are both received and paid to an escrow account, which is any Liability Account in your general ledger.  You can set up a new category here if you don\'t have one already.',
    },
    {
      name: 'FEE',
      required: true,
      displayName: 'Rental Fee Category',
      type: 'tranCategory',
      prompt:
        'Select a transaction category that represents the Fee you are charging the tenant.  Typically this category is "RFEE - Rental Fee" and funds are only received into an Income account on your general ledger',
    },
    {
      name: 'RCOM',
      required: true,
      displayName: 'Rental Commission Category',
      type: 'tranCategory',
      prompt:
        'Select a transaction category that represents the Commission you are paying to an agent.  Typically this category is "RCOM - Rental Commission" and funds are only paid from either: The same income account as the Fee (reducing revenue) OR an expense account which represents Cost ot Goods Sold on your general ledger',
    },
    {
      name: 'PARK',
      required: true,
      displayName: 'Park Category',
      type: 'tranCategory',
      prompt: 'Select a transaction category that represents Park.',
    },
    {
      name: 'KEY',
      required: true,
      displayName: 'Key Category',
      type: 'tranCategory',
      prompt: 'Select a transaction category that represents Key.',
    },
  ],
  template: {
    Deals: [
      {
        Title: '$Title',
        DealNumber: 'AUTO-GENERATE',
        AgentContactName: '$AgentContactName',
        Description: '$Description',
        ContractDate: '$ContractDate',
        TransactionDate: '$TransactionDate',
        BillableDate: '$TransactionDate',
        PayableDate: '$TransactionDate',
        StatusName: '$StatusName',
      },
    ],
    DealTransactions: [
      {
        DealTitle: '$Title',
        Price: '$FMR',
        TranType: 'AR',
        TranCategoryId: '#FMR',
        ContactName: '$TenantName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$FMR',
        TranType: 'AP',
        TranCategoryId: '#FMR',
        ContactName: '$LandlordName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$LMR',
        TranType: 'AR',
        TranCategoryId: '#LMR',
        ContactName: '$TenantName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$LMR',
        TranType: 'AP',
        TranCategoryId: '#LMR',
        ContactName: '$LandlordName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$SEC',
        TranType: 'AR',
        TranCategoryId: '#SEC',
        ContactName: '$TenantName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$SEC',
        TranType: 'AP',
        TranCategoryId: '#SEC',
        ContactName: '$LandlordName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$COMM_SPLIT',
        TranType: 'AP',
        TranCategoryId: '#RCOM',
        ContactName: '$SplitAgentName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$FEE * %AGENT_RENTAL_SPLIT',
        TranType: 'AP',
        TranCategoryId: '#RCOM',
        ContactName: '$AgentContactName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$FEE',
        TranType: 'AR',
        TranCategoryId: '#FEE',
        ContactName: '$TenantName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$KEY_FEE',
        TranType: 'AP',
        TranCategoryId: '#KEY',
        ContactName: '$LandlordName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$KEY_FEE',
        TranType: 'AR',
        TranCategoryId: '#KEY',
        ContactName: '$TenantName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$PARKING',
        TranType: 'AP',
        TranCategoryId: '#PARK',
        ContactName: '$LandlordName',
        Quantity: 1,
        Description: '$Description',
      },
      {
        DealTitle: '$Title',
        Price: '$PARKING',
        TranType: 'AR',
        TranCategoryId: '#PARK',
        ContactName: '$TenantName',
        Quantity: 1,
        Description: '$Description',
      },
    ],
  },
};

export { RentDetailedJSON };
